"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    children: [(0, jsx_runtime_1.jsx)("circle", {
      cx: "10",
      cy: "10",
      r: "10",
      fill: "#757D8A"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.77747 14.1851C10.2155 14.1851 10.5706 13.83 10.5706 13.392C10.5706 12.954 10.2155 12.5989 9.77747 12.5989C9.33945 12.5989 8.98438 12.954 8.98438 13.392C8.98438 13.83 9.33945 14.1851 9.77747 14.1851Z",
      fill: "white"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M8.58789 7.44393C9.38098 6.25423 11.1223 6.16802 11.7603 7.44393C11.9585 7.84041 12.1568 9.03008 10.9672 9.62486C9.77753 10.2196 9.77753 10.4668 9.77753 11.0128",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

exports.default = Icon;